export default "https://cdn-static.gokick.com/assets/643951300d065933ed58add7baf5b7b086396c88/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";